module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMwMDAwNjciIGQ9Ik0wIDBoMjEzLjk3djQ4MEgweiIvPgogICAgPHBhdGggZmlsbD0icmVkIiBkPSJNNDI2LjAzIDBINjQwdjQ4MEg0MjYuMDN6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmYwIiBkPSJNMjEzLjk3IDBoMjEyLjA2djQ4MEgyMTMuOTd6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/td.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/td.svg
// module chunks = 0